import React from 'react';
import App from '@app';
import { AddButton, Body, PageHeader } from '@components';
import TableNotificacao from './TableNotificacao';
import { useHistory } from 'react-router-dom';

export default function Notificacao() {
  const history = useHistory();

  return (
    <App>
      <Body>
        <PageHeader
          title='Notificação dos Conectores'
          extra={[
            <AddButton
              key='1'
              type='primary'
              tooltipTitle='Configurar email'
              onClick={() => history.push('/conectores/notificacao/email/-1')}
            />,
          ]}
        >
          <TableNotificacao />
        </PageHeader>
      </Body>
    </App>
  );
}
